const constants = {
  GET_VERSION_PENDING: 'GET_VERSION_PENDING',
  GET_VERSION_SUCCESS: 'GET_VERSION_SUCCESS',
  GET_VERSION_FAILURE: 'GET_VERSION_FAILURE',
};

export default constants;
